var map = {
	"./ba.json": 50340,
	"./en.json": 44174,
	"./es.json": 46725,
	"./fr.json": 94605,
	"./hr.json": 36759,
	"./ro.json": 22354,
	"./ru.json": 74600,
	"./sl.json": 37110,
	"./sr.json": 78912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81266;